<template>
    <page>
        <q-table v-if="options" class="shadow-25 v-list" dense :class="'bg-' + color" style="width:90vw;"
            :style="{ 'max-width': width }" :pagination.sync="pagination" :infinite-scroll="infiniteScroll"
            :loading="isLoading" @request="refreshRows" :data.sync="results.data" :hide-header="results.data.length == 0"
            :columns="options.columns" :filter="filter" :visible-columns="visibleColumns"
            :rows-per-page-options="options.rowsPerPageOptions" :filterFields="options.columns" row-key="id">
            <v-header slot="top" slot-scope="props" :title="$metaInfo.title" :icon="options.icon">
                <template slot="right">
                    <v-button v-if="options.canCreate" flat round dense color="primary" icon="add circle outline"
                        dusk="create-icon" @click="createRow">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('add new') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-show="!isActiveToolbar('filter')" flat round dense no-caps color="primary" icon="search"
                        dusk="search-icon" @click="toggleToolbar('filter')">
                        <q-tooltip v-show="!isActiveToolbar('filter')" anchor="top left" self="bottom middle">
                            {{ $T('search') }}
                        </q-tooltip>
                    </v-button>
                    <q-input v-if="isActiveToolbar('filter')" hide-underline autofocus color="primary" v-model="tempFilter"
                        :placeholder="$T('search')" @input="updateFilter" class="bg-search" dusk="search-inputw"
                        :before="[{ icon: 'search', handler() { toggleToolbar('') } }]" />

                    <v-button v-show="!isActiveToolbar('columns') && columnsOptions.length > 0" flat round dense no-caps
                        color="primary" icon="view column" dusk="columns-icon" @click="toggleToolbar('columns')">
                        <q-tooltip v-show="!isActiveToolbar('columns')" anchor="top left" self="bottom middle">
                            {{ $T('columns') }}
                        </q-tooltip>
                    </v-button>
                    <select-extended v-show="isActiveToolbar('columns')" select-all multiple toggle hide-underline
                        color="primary" v-model="visibleColumns" :options="columnsOptions" :display-value="$T('columns')"
                        dusk="columns-select" :before="[{ icon: 'view column', handler() { toggleToolbar('columns') } }]" />

                    <v-table-filter :slug="slug" @refreshTable="useFilters" />

                    <v-button v-if="options.exportRoute" flat round dense no-caps color="primary" icon="cloud download"
                        dusk="export-icon" @click="$router.push({ name: options.exportRoute, query: queryExport })">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('export') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-if="options.importRoute" flat round dense no-caps color="primary" icon="cloud upload"
                        dusk="import-icon" @click="$router.push({ name: options.importRoute })">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('import') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-if="options.updateImportRoute" flat round dense no-caps color="primary" icon="update"
                        dusk="import-update-icon" @click="$router.push({ name: options.updateImportRoute })">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('update data') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-if="options.importModelRoute && ['Admin', 'Backoffice'].includes(user.role.name)" flat round dense no-caps color="primary" icon="cloud"
                        dusk="import-icon" @click="$router.push({ name: options.importModelRoute })" class="import-model">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('import') + ' ' + $T('models') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-if="options.importSkuRoute && ['Admin', 'Backoffice'].includes(user.role.name)" flat round dense no-caps color="primary" icon="cloud"
                        dusk="import-icon" @click="$router.push({ name: options.importSkuRoute })" class="import-sku">
                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('import') + ' ' + $T('sku') }}
                        </q-tooltip>
                    </v-button>
                    <v-button v-if="options.changeOrderStatusCompletedNotReturnedRoute" flat round dense no-caps
                        color="primary" icon="save" dusk="import-icon"
                        @click="$router.push({ name: options.changeOrderStatusCompletedNotReturnedRoute })">

                        <q-tooltip anchor="top left" self="bottom middle">
                            {{ $T('Change Orders Status to Completed Not Returned') }}
                        </q-tooltip>
                    </v-button>
                </template>
            </v-header>
            <q-td slot="body-cell-identifier" slot-scope="props" :props="props">
                <q-chip small :class="{'bg-blue': ['Yes', 'Sim'].includes(props.row.is_circular_lending) }">{{ props.value }}</q-chip>
            </q-td>
            <q-td slot="body-cell-last_order.id" slot-scope="props" :props="props">
              <div v-if="props.value" >
                <q-btn flat :label="props.value"
                       :color="props.row['last_order.stock_order_status_id'] == 1 ? 'red' : 'highlight'"
                       @click="redirect(props.value)" />
              </div>
            </q-td>
            <q-td slot="body-cell-roles" slot-scope="props" :props="props">
                <span  v-for="(item, index) in props.value">{{ index !== 0 ? ' / ' : '' }}{{ item.name }}</span>
            </q-td>
            <q-td slot="body-cell-minimum_stock_alert" slot-scope="props" :props="props">
                <q-icon name="info" size="2.2em" :color="props.value.length > 0 ? 'red' : 'highlight'" />
            </q-td>
            <q-td slot="body-cell-lending_kit_models" slot-scope="props" :props="props">
              <span  v-for="(item, index) in props.value" v-if="item.is_active === 1">{{ index !== 0 ? ' / ' : '' }}{{ item.description }}</span>
            </q-td>
            <q-td slot="body-cell-image" slot-scope="props" :props="props">
                <img v-if="props.value" height="100px" :src="`/storage/uploads/${props.value}`" />
            </q-td>
            <q-td slot="body-cell-lending_kit_color.image" slot-scope="props" :props="props">
                <img v-if="props.value" height="100px" :src="`/storage/uploads/${props.value}`" />
            </q-td>
            <q-td slot="body-cell--actions" slot-scope="cell" class="text-center" style="width: 100px;">
                <v-button color="info" v-for="(action, index) in options.actions" class="no-shadow on-left"
                    :title="`${$t(action.name)}`" v-show="userCanSee(action)" :key="`${index}-action`"
                    :dusk="`${action.name}-action-button`" :icon="action.icon" size="sm" round dense>
                    <q-tooltip anchor="top left" self="bottom middle">
                        {{ $t(action.name) }}
                    </q-tooltip>
                    <q-popover>
                        <div class="group text-center">
                            <p><strong>{{ $T('Do you want') }} {{ $T(action.name) }}?</strong></p>
                            <v-button class="no-shadow capitalize" color="negative" no-caps dusk="confirm-action-button"
                                @click.prevent="runAction(action, cell.row.id)" v-close-overlay>
                                {{ $t('execute') }}
                            </v-button>
                            <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay
                                dusk="cancel-action-button">
                                {{ $t('cancel') }}
                            </v-button>
                        </div>
                    </q-popover>
                </v-button>
                <v-button v-show="!options.isTrash" :disable="isLoading" color="info" class="no-shadow on-left"
                    :dusk="`${cell.row.id}-edit-button`" :icon="options.canCreate ? 'edit' : 'visibility'"
                    @click.prevent="editRow(cell.row.id)" size="sm" round dense />
                <v-button v-show="!options.isTrash && options.canDelete" :disable="isLoading" color="negative"
                    class="no-shadow" :dusk="`${cell.row.id}-delete-button`" icon="delete" size="sm" round dense>
                    <q-popover>
                        <div class="group text-center">
                            <p><strong>{{ $T('are you sure?') }}</strong></p>
                            <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                dusk="confirm-delete-button" @click="deleteRow(cell.row.id)" v-close-overlay>
                                {{ $t('delete') }}
                            </v-button>
                            <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay
                                dusk="cancel-delete-button">
                                {{ $t('cancel') }}
                            </v-button>
                        </div>
                    </q-popover>
                </v-button>
                <v-button v-show="options.isTrash" :disable="isLoading" color="faded" class="no-shadow"
                    :dusk="`${cell.row.id}-restore-button`" icon="restore page" @click.prevent="restoreRow(cell.row.id)"
                    small round flat dense />
                <v-button v-show="options.isTrash" :disable="isLoading" color="faded" class="no-shadow"
                    icon="delete forever" :dusk="`${cell.row.id}-force-delete-button`" small round flat>
                    <q-popover>
                        <div class="group text-center">
                            <p><strong>{{ $T('are you sure?') }}</strong></p>
                            <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                dusk="confirm-force-delete-button" @click="deleteRowForever(cell.row.id)" v-close-overlay>
                                {{ $t('delete forever') }}
                            </v-button>
                            <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay
                                dusk="confirm-force-delete-button">
                                {{ $t('cancel') }}
                            </v-button>
                        </div>
                    </q-popover>
                </v-button>
            </q-td>
            <q-td slot="body-cell-active" slot-scope="cell" class="text-center" style="width: 100px;">
                <div class="text-left">
                    <q-icon v-if="cell.row.active" size="1.5em" color="green" name="done"></q-icon>
                    <q-icon v-else color="red" size="1.5em" name="close"></q-icon>
                </div>
            </q-td>
            <q-td slot="body-cell-is_active" slot-scope="cell" class="text-center" style="width: 100px;">
                <div class="text-left">
                    <q-icon v-if="cell.row.is_active" size="1.5em" color="green" name="done"></q-icon>
                    <q-icon v-else color="red" size="1.5em" name="close"></q-icon>
                </div>
            </q-td>
        </q-table>
        <spinner-iqos size="60px" v-else />
    </page>
</template>

<script>

import {
    debounce,
    QTable,
    QTd,
    QInput,
    QToggle,
    QPopover,
    QTooltip,
    QRadio,
    Notify
} from 'quasar-framework'
import axios from 'axios'
import { userPreferences } from '../store/modules/userPreferences'
import { mapGetters } from 'vuex'
import VDatetime from "./form/VDatetime.vue"
import VTableFilter from './form/VTableFilter.vue'

const PER_PAGE = 10

const PAGINATION_QUANTITIES = [10, 20, 50, 100]

export default {
    name: 'list',

    metaInfo() {
        return {
            title: (this.isLoading ? this.$T('loading') + ' ' : '') + (this.options ? this.$T(this.options.plural) +
                (this.options.isTrash ? ' ' + this.$t('in trash') : '') : '...')
        }
    },

    components: {
        VDatetime,
        VTableFilter,
        QTable,
        QTd,
        QInput,
        QToggle,
        QPopover,
        QTooltip,
        QRadio,
    },
    props: {
        slug: {
            type: String,
            required: true
        },
        baseRoute: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'white'
        },
        width: {
            type: String,
            default: '100%'
        },
        activateMeta: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        redirect(value) {
            localStorage.setItem("openModal", value);
            this.$router.push({ name: `backoffice.stock-orders` })
        },

        updateFilter: debounce(function () {
            this.filter = this.tempFilter
        }, 500),

        notify(message, detail, actions = [], type = 'positive') {
            this.$q.notify({
                type,
                position: 'top',
                message,
                detail,
                timeout: 5000,
                actions
            })
        },

        useFilters(filters) {
            this.filtersChosen = filters
            this.refreshRows()
        },

        getPaginationFromQuery() {
            if (!this.options) return
            let page = parseInt(getNested('page', this.$route.query, 1))
            let rowsPerPage = parseInt(getNested('per_page', this.$route.query, PER_PAGE))
            let pagination = {
                page,
                rowsPerPage,
                sortBy: getNested('sort_by', this.$route.query, null), // String, column "name" property value
                descending: getNested('descending', this.$route.query, true).toString() === 'true' ? true : false,
                rowsNumber: this.pagination.rowsNumber || page * rowsPerPage // specifying this determines pagination is server-side
            }
            let filter = getNested('search', this.$route.query, '')

            if (objectToString(pagination) !== objectToString(this.pagination) || this.filter !== filter) {
                this.filter = filter
                this.pagination = pagination
            }
        },

        async refreshRows({ pagination, filter } = { pagination: null, filter: null }) {
            if (!pagination) pagination = this.pagination
            if (!filter) filter = this.filter

            let query = { // ETL from component to API
                page: pagination.page,
                sort_by: pagination.sortBy,
                descending: pagination.descending,
                per_page: pagination.rowsPerPage,
                search: filter,
            }

            if (this.filtersChosen) {
                query = {
                    ...query,
                    ...this.filtersChosen
                }
            }

            // QTable does not update the pagination and filter models directly
            this.pagination = pagination
            this.tempFilter = this.filter = filter

            if (objectToString(this.$route.query) === '{}' || pagination.page === 0)
                this.$router.replace({ query: query })
            else if (objectToString(query) !== objectToString(this.$route.query))
                this.$router[this.infiniteScroll === true ? 'replace' : 'push']({ query: query })

            await this.request('get', this.options.resourcePath, { params: query })
                .then((response) => {
                    // we also set (or update) rowsNumber
                    this.pagination.rowsNumber = response.meta.total

                    // then we update the rows with the fetched ones
                    this.results.meta = response.meta
                    this.results.links = response.links
                    if (response.meta.current_page == 1 || !this.infiniteScroll)
                        this.results.data = response.data
                    else
                        response.data.forEach(r => this.results.data.push(r))
                })
        },

        createRow() {
            this.$router.push({ name: `${this.baseRoute}.create`, params: { activateMeta: this.activateMeta } })
        },

        editRow(id) {
            this.$router.push({ name: `${this.baseRoute}.edit`, params: { id } })
        },

        deleteRow(id) {
            this.request('delete', this.itemPath(id))
                .then(data => {
                    this.notify(this.$T('success'), data.success.message, [{
                        label: this.$t('undo'), handler: function () {
                            this.restoreRow(data.model.id);
                        }.bind(this)
                    }])
                    this.refreshRows()
                })
        },

        deleteRowForever(id) {
            this.request('delete', `${this.itemPath(id)}\/force`)
                .then(data => {
                    this.notify(this.$T('success'), data.success.message)
                    this.refreshRows()
                })
        },

        restoreRow(id) {
            this.request('get', `${this.itemPath(id)}\/restore`)
                .then(data => {
                    this.notify(this.$T('success'), data.success.message)
                    this.refreshRows()
                })
        },

        itemPath(id) {
            return `${this.options.resourcePath}\/${id}`
        },

        isActiveToolbar(item) {
            return this.activeToolbar == item
        },

        toggleToolbar(item) {
            this.activeToolbar = this.activeToolbar == item ? null : item
        },

        /**
         * Submit a request.
         *
         * @param {string} requestType
         * @param {string} url
         */
        request(requestType, url, data = {}) {
            this.isLoading = true

            return new Promise((resolve, reject) => {
                // this.$worker.run((requestType, url, data) => {
                //     return axios[requestType](url, data)
                // }, [requestType, url, data])
                //         .then(response => {
                //             this.onSuccess(response.data);
                //
                //             resolve(response.data);
                //         })
                //         .catch(error => {
                //             this.onFail(error.response.data);
                //
                //             reject(error.response.data);
                //         })
                axios[requestType](url, data)
                    .then(response => {
                        this.onSuccess(response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        this.onFail(error.response.data);

                        reject(error.response.data);
                    })
            });
        },

        /**
         * Handle a successful request.
         *
         * @param {object} data
         */
        onSuccess(data) {
            this.isLoading = false
        },

        /**
         * Handle a failed request.
         *
         * @param {object} errors
         */
        onFail(data) {
            this.isLoading = false

            if (data && data.error)
                this.notify(this.$T('error'), data.error.message, [], 'negative')
        },

        async describe() {
            await this.$store.dispatch('crud/fetchList', this.slug)
        },

        async init() {
            this.filtersChosen = null
            await this.describe()
            this.results.data = []
            this.getPaginationFromQuery()
            if (!this.infiniteScroll) {
                this.refreshRows()
            }
        },

        async reload() {
            await this.init()
            await this.refreshRows()
        },
        runAction(action, resourceId) {
            axios.post(`${action.endpoint}`, {
                resourceId
            })
                .then(response => {
                    Notify.create({
                        color: response.data.success ? 'positive' : 'danger',
                        icon: response.data.success ? 'thumb_up' : 'error',
                        message: response.data.message,
                        //detail: response.data.success ? this.$T('Action Executed'): ,
                        position: 'bottom'
                    })
                    this.refreshRows()
                })
        },
        userCanSee(action) {
            return action.can_see.findIndex((role_id) => role_id === this.user.role_id) > -1
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        slug: 'reload',
        $route: 'getPaginationFromQuery',
        '$route': {
            handler: function(route) {
                const { query = {}, name = null } = route;

                if(['backoffice.stock-management.index'].includes(name)) {
                    this.queryExport = {};
                    Object.keys(query).map((key) => {
                        if(key == 'search' || key.substring(0, 7) == 'filter_') {
                            this.queryExport[key] = query[key]
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
        options() {
            let options = deepCopy(this.$store.getters['crud/listDescription'](this.slug))
            if (!options) return

            // Localize labels and set default values for columns
            if (options.columns) {
                let columns = options.columns
                // For some reason PHP casts some arrays as objects. Convert it back to array here:
                if (typeof columns === "object")
                    columns = Object.keys(columns).map(key => (columns[key]))
                options.columns = columns.map(column => ({
                    name: column.field,
                    label: this.$T(column.label),
                    field: column.field,
                    align: column.align || 'left',
                    sortable: column.sortable || false,
                    required: column.required || false,
                }))
            }

            let defaultOptions = deepCopy(this.defaultOptions)

            Object.assign(defaultOptions, options)

            if (options.columns && options.columns[options.columns.length - 1].name != '-actions')
                options.columns.push({
                    label: this.$T('actions'),
                    name: '-actions',
                    align: 'center',
                    required: true
                })

            return defaultOptions
        },
        columnsOptions() {
            var a = this.options.columns.filter(c => !c.required).map(c => ({ value: c.field, label: c.label }))
            return a;
        },
        visibleColumns: userPreferences('visibleColumns', []),
        infiniteScroll: userPreferences('infiniteScroll', false)
    },
    data() {
        return {
            activeToolbar: this.$route.query.search ? 'filter' : '',
            defaultOptions: {
                plural: 'items',
                isTrash: false,
                singular: 'item',
                rowsPerPageOptions: PAGINATION_QUANTITIES
            },
            filtersChosen: null,

            startDate: '',
            endDate: '',
            checked: false,
            select: null,

            selectOptions: [
                {
                    label: 'Option 1',
                    value: 'option1'
                },
                {
                    label: 'Option 2',
                    value: 'option2'
                }
            ],
            isLoading: false,
            pagination: {},
            filter: '',
            filterFields: [],
            tempFilter: '',
            filterValues: [],
            results: {
                meta: {
                    total: 0,
                    total_unfiltered: 0,
                    total_in_trash: 0,
                },
                data: [],
            },
            queryExport: {}
        }
    }
}
</script>

<style>
    .import-model,
    .import-sku {
        position: relative;
    }
    .import-model::before,
    .import-sku::before {
        content: 'M';
        color: #fff;
        font-weight: bold;
        position: absolute;
        left: 0;
        right: 0;
        font-size: 10px;
        top: calc(50% - 5px);
    }
    .import-sku::before {
        content: 'S';
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/List.vue